export default __webpack_public_path__ + "static/media/Picture6.525a9c7b.jpg";